import { render, staticRenderFns } from "./StatisticsTradesExtra.vue?vue&type=template&id=cccaaf82&"
import script from "./StatisticsTradesExtra.vue?vue&type=script&lang=js&"
export * from "./StatisticsTradesExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports